//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import Requisites from '~/views/UserRequisites/Requisites/Table.vue';

export default {
  components: {
    Requisites,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadRequisites({ userId: this.$router.currentRoute.params.id }),
      this.loadCurrencies(),
      this.loadPaymentMethods(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('userRequisites', {
      loadRequisites: 'loadData',
    }),
    ...mapActions('tradersCurrencies', {
      loadCurrencies: 'loadData',
    }),
    ...mapActions('tradersPaymentMethods', {
      loadPaymentMethods: 'loadData',
    }),
  },
};
